export default __webpack_public_path__ + "static/fa-regular-400-491974d108fe4002b2aaf7ffc48249a0.ttf";